$(function() {
	
	G.ajaxFormOnSubmit({
		form: '#forgot-form',
		ajax_function: 'sendReset',
		loading_message: 'Sending...',
	});
});